
<template>
  <main class="topper-page">

    <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Toppers List</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">Academics</a></span>
                                        </div>
                                        <span>Toppers List</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->
    <!-- Toppers Section -->
    <section class="topper-section">

      <div class="topper-heading">
        <h2>VEDANTA GURUKUL PUBLIC SENIOR SECONDARY SCHOOL, REENGUS <br>RBSE X BOARD RESULT 2025-26</h2>
        <div class="heading-decoration">
          <span></span>
          <i>★</i>
          <span></span>
        </div>
      </div>

      <div class="topper-container">

        <div
          class="topper-card"
          v-for="(student, index) in toppers"
          :key="index"
        >

          <div class="topper-image-area">

            <div class="laurel-frame">
              <img
                :src="student.photo"
                :alt="student.name"
                class="student-photo"
              />
            </div>

            <div class="percentage-ribbon">
              {{ student.percentage }}
            </div>

          </div>

          <div class="topper-details">
            <h3>{{ student.name }}</h3>
            <p>{{ student.parent }}</p>
          </div>

        </div>

      </div>
    </section>

    <!-- RBSE XII Board Result Section -->
<section class="topper-section class-xii-section">

  <div class="topper-heading">
    <h2>
       RBSE XII BOARD RESULT 2025-26
    </h2>
  </div>

  <!-- SCIENCE STREAM -->
  <div class="stream-section">

    <div class="stream-title science-title">
      SCIENCE<br>STREAM
    </div>

    <div class="topper-container">

      <div
        class="topper-card"
        v-for="(student, index) in scienceToppers"
        :key="'science-' + index"
      >

        <div class="topper-image-area">

          <div class="laurel-frame">
            <img
              :src="student.photo"
              :alt="student.name"
              class="student-photo"
            />
          </div>

          <div class="percentage-ribbon">
            {{ student.percentage }}
          </div>

        </div>

        <div class="topper-details">
          <h3>{{ student.name }}</h3>
          <p>{{ student.parent }}</p>
        </div>

      </div>

    </div>

  </div>

  <!-- COMMERCE STREAM -->
  <div class="stream-section">

    <div class="stream-title commerce-title">
      COMMERCE<br>STREAM
    </div>

    <div class="topper-container">

      <div
        class="topper-card"
        v-for="(student, index) in commerceToppers"
        :key="'commerce-' + index"
      >

        <div class="topper-image-area">

          <div class="laurel-frame">
            <img
              :src="student.photo"
              :alt="student.name"
              class="student-photo"
            />
          </div>

          <div class="percentage-ribbon">
            {{ student.percentage }}
          </div>

        </div>

        <div class="topper-details">
          <h3>{{ student.name }}</h3>
          <p>{{ student.parent }}</p>
        </div>

      </div>

    </div>

  </div>

</section>
 <div class="topper-heading">
        <h2>RBSE X BOARD RESULT 2025-26</h2></div>
 <section class="marks-result">

      <!-- 100/100 Speech Bubble -->
      <div class="marks-bubble">
        <h3>STUDENTS SCORED</h3>
        <div class="marks-score">
          <span>100</span>
          <span>100</span>
        </div>
      </div>

      <!-- Students -->
      <div class="marks-grid">

        <div
          class="marks-student"
          v-for="(student, index) in students"
          :key="index"
        >

          <div class="marks-photo-area">

            <img
              :src="student.photo"
              :alt="student.name"
              class="marks-photo"
            />

            <!-- Percentage -->
            <div class="marks-ribbon">
              {{ student.percentage }}
            </div>

          </div>

          <div class="marks-student-info">
            <h3>{{ student.name }}</h3>

            <div class="marks-subject">
              <span class="marks-fraction">
                <span>{{ student.marks }}</span>
                <span>{{ student.total }}</span>
              </span>

              <strong>IN {{ student.subject }}</strong>
            </div>
          </div>

        </div>

      </div>

      <!-- 100% Result Badge -->
      <div class="marks-result-badge">
        <strong>100%</strong>
        <span>RESULT</span>
      </div>

    </section>

  </main>
</template>

<script>
export default {
  name: "TopperListView",

  data() {
    return {
      toppers: [
        {
          name: "NARENDRA",
          percentage: "98.00%",
          parent: "S/O Mr. KANARAM",
          photo: "/img/toppers/narendra.png",
        },
        {
          name: "SAKSHI JANGID",
          percentage: "97.67%",
          parent: "D/O Mr. MUKESH JANGID",
          photo: "/img/toppers/SAKSHI JANGID.png",
        },
        {
          name: "BHUMIKA SHARMA",
          percentage: "96.50%",
          parent: "D/O Mr. MANISH SHARMA",
          photo: "/img/toppers/BHUMIKA SHARMA.png",
        },
        {
          name: "RITIKA DEVANDA",
          percentage: "96.00%",
          parent: "D/O Mr. VIKRAM SINGH DEVANDA",
          photo: "/img/toppers/RITIKA DEVANDA.png",
        },
        {
          name: "RIYANSHI YADAV",
          percentage: "96.00%",
          parent: "D/O Mr. SARDAR YADAV",
          photo: "/img/toppers/RIYANSHI YADAV.png",
        },
        {
          name: "SATYAM PRAJAPATI",
          percentage: "95.67%",
          parent: "S/O Mr. SURENDRA PRAJAPATI",
          photo: "/img/toppers/SATYAM PRAJAPATI.png",
        },
        {
          name: "SHINU KUMARI ",
          percentage: "95.17%",
          parent: "D/O Mr. RANJAY THAKUR ",
          photo: "/img/toppers/SHINU KUMARI.png",
        },
        {
          name: "RAGHAV SHARMA ",
          percentage: "95.67%",
          parent: "S/O Mr. RAJENDRA SHARMA ",
          photo: "/img/toppers/RAGHAV SHARMA.png",
        },
      ],
      scienceToppers: [
  {
    name: "SHRUTI SINGH",
    percentage: "96.60%",
    parent: "D/O Mr. RAJ KAMAL SINGH",
    photo: "/img/toppers/SHURUTI SINGH.png",
  },
  {
    name: "RUBY CHOUDHARY",
    percentage: "95.80%",
    parent: "D/O Mr. RAKESH SINGH",
    photo: "/img/toppers/RUBY CHOUDHARY.png",
  },
  {
    name: "DISHA KUMAWAT",
    percentage: "95.00%",
    parent: "D/O Mr. BHAGCHAND KUMAWAT",
    photo: "/img/toppers/DISHA KUMAWAT.png",
  },
],

commerceToppers: [
  {
    name: "AYUSH CHHIPA",
    percentage: "95.80%",
    parent: "D/O Mr. JANKILAL CHHIPA",
    photo: "/img/toppers/AYUSH CHHIPA.png",
  },
],

 students: [
        {
          name: "NARENDRA",
          percentage: "98.00%",
          marks: "100",
          total: "100",
          subject: "SCIENCE & S.ST",
          photo: "/img/toppers/narendra.png",
        },
        {
          name: "RITIKA DEVANDA",
          percentage: "96.00%",
          marks: "100",
          total: "100",
          subject: "SCIENCE",
          photo: "/img/toppers/RITIKA DEVANDA.png",
        },
        {
          name: "RAGHAV SHARMA",
          percentage: "95.17%",
          marks: "100",
          total: "100",
          subject: "MATH",
          photo: "/img/toppers/RAGHAV SHARMA.png",
        },
        {
          name: "NISHANT DHAYAL",
          percentage: "94.00%",
          marks: "100",
          total: "100",
          subject: "SCIENCE",
          photo: "/img/toppers/NISHANT DHAYAL.jpg",
        },
        {
          name: "DEEPANSHU SABOO",
          percentage: "93.00%",
          marks: "100",
          total: "100",
          subject: "MATH",
          photo: "/img/toppers/DEEPANSHU SABOO.jpg",
        },
        {
          name: "PRAGYA RATHORE",
          percentage: "91.67%",
          marks: "100",
          total: "100",
          subject: "SCIENCE",
          photo: "/img/toppers/PRAGYA RATHORE.jpg",
        },
        {
          name: "ANSHIKA KUMAWAT",
          percentage: "91.17%",
          marks: "100",
          total: "100",
          subject: "SCIENCE",
          photo: "/img/toppers/ANSHIKA KUMAWAT.jpg",
        },
      ],
    };
  },
};
</script>


